
import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { DeleteSinglecaseStudy } from '../../actions/caseStudyAction'

function CaseStudyCard({val}) {

    const dispatch = useDispatch()
  
    const handleDelete = async () => {
      const userConfirmed = window.confirm('Are you sure you want to delete?');
      if (userConfirmed) {
        try {
          await dispatch(DeleteSinglecaseStudy(val.url));
          window.location.reload();
        } catch (error) {
          console.error('Error deleting blog:', error);
        }
      } else {
      }
    };
  

    return (
        <div className='card'>
            <div className='card_div'>
                <div className='img_div'>
                    <img src={val.imageurl} alt='' />
                </div>
                <div className='card_text_div'>
                    <div className='card_heading'>{`${(val.mainheading)?.substring(0, 30)}...`}</div>
                    <div className='card_para'>{`${(val.case_description)?.substring(0, 75)}...`}
                    </div>
                </div>
                <div className='card_button_div'>
                    <Link to={`/update-case-study/${val?.url}`} className='Link_button'>Edit</Link>
                    <button type="button" onClick={handleDelete} className='Link_button'>Delete</button>
                </div>
            </div>
        </div>
    )
}

export default CaseStudyCard
